"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identityType = exports.genderType = exports.Channel = exports.Role = exports.Permission = void 0;
;
var Permission;
(function (Permission) {
    Permission[Permission["Read"] = 0] = "Read";
    Permission[Permission["Write"] = 1] = "Write";
    Permission[Permission["Delete"] = 2] = "Delete";
})(Permission = exports.Permission || (exports.Permission = {}));
var Role;
(function (Role) {
    Role[Role["Administrator"] = 0] = "Administrator";
    Role[Role["Colaborator"] = 1] = "Colaborator";
    Role[Role["Company"] = 2] = "Company";
    Role[Role["Patient"] = 3] = "Patient";
    Role[Role["SuperCollaborator"] = 4] = "SuperCollaborator";
    Role[Role["SuperCompany"] = 5] = "SuperCompany";
    Role[Role["Freelance"] = 6] = "Freelance";
})(Role = exports.Role || (exports.Role = {}));
var Channel;
(function (Channel) {
    Channel[Channel["Email"] = 0] = "Email";
    Channel[Channel["Sms"] = 1] = "Sms";
    Channel[Channel["Push"] = 2] = "Push";
})(Channel = exports.Channel || (exports.Channel = {}));
var genderType;
(function (genderType) {
    genderType[genderType["Unknown"] = 0] = "Unknown";
    genderType[genderType["Male"] = 1] = "Male";
    genderType[genderType["Female"] = 2] = "Female";
})(genderType = exports.genderType || (exports.genderType = {}));
var identityType;
(function (identityType) {
    identityType[identityType["NIF"] = 0] = "NIF";
    identityType[identityType["NIE"] = 1] = "NIE";
    identityType[identityType["Passport"] = 2] = "Passport";
})(identityType = exports.identityType || (exports.identityType = {}));
